import { useCallback, useReducer } from 'react';

enum DisableAction {
  Put,
  Pop,
}

/**
 * while the request is running, we do the actions element disabled
 */
export function useDisableAction() {
  const [disabledIds, dispatch] = useReducer(
    (state: (string | number)[], action: { type: DisableAction; id: string | number }) => {
      switch (action.type) {
        case DisableAction.Put:
          return [...state, action.id];
        case DisableAction.Pop:
          return state.filter(di => di !== action.id);
        default:
          return state;
      }
    },
    []
  );

  const handleClick = useCallback((event: any, action: (event: any) => any | Promise<any>, id: string | number = 0) => {
    if (typeof action === 'function') {
      const result = action(event);
      if (result instanceof Promise) {
        dispatch({ type: DisableAction.Put, id });
        result.finally(() => {
          dispatch({ type: DisableAction.Pop, id });
        });
      }
    }
  }, []);

  return { disabledIds, handleClick };
}
